<!-- 流量购买使用促销码 -->
<template>
    <div class="coupon-wrap">
        <div class="coupon_switch clear">
            <button v-if="Module_Coupon" class="private_coupon" :class="{'selected': select_type === 'private'}" @click="selectType('private')">{{$t('Enter_Promo_Coupon')}}</button>
            <button class="public_coupon" :class="{'selected': select_type === 'public'}" @click="selectType('public')">{{$t('Enter_Promo_code')}}</button>
            <i class="iconfont iconm_close_tip coupon_close" @click.stop="e_closeDialog"></i>
        </div>
        <!-- 个人coupon -->
        <div class="private_coupon_box" v-if="select_type === 'private'">
            <!-- 可用coupon -->
            <div class="available_coupon" v-if="dataList.availableList.length">
                <label class="type_title">{{$t('settlement_Available_coupon')}}<span>({{dataList.availableList.length}})</span></label>
                <div class="coupon_wrap" :class="{'coupon_wrap_all':dataList.unavailableList.length==0}">
                    <div class="coupon_li" v-for="(item,i) in dataList.availableList" :key="i" :class="{'active':comActive[i]}" @click.stop="e_chooseCoupon(item,i)">
                        <img class="selected" :src="$NeWDomain.getImgUrl('imgs/coupon_select.png')" alt="coupon select">
                        <div class="coupon_item clear">
                            <div class="coupon_denomination ilb fl">
                                <div class="coupon_left fl" :class="{'coupon_full_reduction_percent':item.promotionMode=='P01','coupon_full_reduction':item.promotionMode=='P02','coupon_percent_reduction':item.promotionMode=='P03','coupon_direct_reduction':item.promotionMode=='P04'}">
                                    <p>{{item.preferentialRatio}}</p>
                                    <span>{{item.offerLogo}}</span>
                                </div>
                            </div>
                            <div class="coupon_right fl">
                                <p class="coupon_name text-row">{{item.promotionName[$i18n.locale] || item.promotionName['en-US']}}</p>
                                <p class="coupon_title ellipsis">{{item.promotionTitle[$i18n.locale] || item.promotionTitle['en-US']}}</p>
                                <p class="coupon_date"><span>{{item.validPeriod}}</span><i class="more" :class="{'active':showUsefulDesc[i]}" @click.stop="e_usefulDescToggle(i)"></i></p>
                            </div>
                            <div class="coupon_desc_wrap coupon_desc_useful">
                                <div class="coupon_desc">
                                    <label>{{item.promotionRemark[$i18n.locale] || item.promotionRemark['en-US']}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 不可用coupon -->
            <div class="unavailable_coupon" v-if="dataList.unavailableList.length">
                <label class="type_title">{{$t('settlement_Unavailable_coupon')}}<span>({{dataList.unavailableList.length}})</span></label>
                <div class="coupon_wrap" :class="{'coupon_wrap_all':dataList.availableList.length==0}">
                    <div class="coupon_li" v-for="(items,index) in dataList.unavailableList" :key="index">
                        <div class="coupon_item clear">
                            <div class="coupon_denomination ilb fl">
                                <div class="coupon_left coupon_useless fl">
                                    <p>{{items.preferentialRatio}}</p>
                                    <span>{{items.offerLogo}}</span>
                                </div>
                            </div>
                            <div class="coupon_right fl">
                                <p class="coupon_name text-row">{{items.promotionName[$i18n.locale] || items.promotionName['en-US']}}</p>
                                <p class="coupon_title">{{items.promotionTitle[$i18n.locale] || items.promotionTitle['en-US']}}</p>
                                <p class="coupon_date"><span>{{items.validPeriod}}</span><i class="more" :class="{'active':showUselessDesc[index]}" @click.stop="e_uselessDescToggle(index)"></i></p>
                            </div>
                            <div class="coupon_desc_wrap coupon_desc_useless">
                                <div class="coupon_desc">
                                    <label>{{items.promotionRemark[$i18n.locale] || items.promotionRemark['en-US']}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="nullList" v-if="dataList.unavailableList.length==0">
                        <img :src="$NeWDomain.getImgUrl('imgs/ic_noData.png')">
                        <p v-text="$t('member_myFlow_noList')"></p>
                    </div>
                </div>
            </div>
            <div class="nullList" v-if="dataList.availableList.length==0 && dataList.unavailableList.length==0">
                <img :src="$NeWDomain.getImgUrl('imgs/ic_noData.png')">
                <p v-text="$t('coupons.no_data')"></p>
            </div>
        </div>
        <!-- 公共coupon -->
        <div class="public_coupon_box" v-else>
            <label class="title">{{$t('please_Enter_Promo_code')}}</label>
            <input type="text" class="coupon_input" v-model="publicCouponCode" :placeholder="$t('Enter_Promo_code')">
            <p :class="{'available':dataList.publicValid,'unavailable':!dataList.publicValid}">{{dataList.publicTips}}</p>
        </div>
        <div class="operator"><button class="buy_now" @click="e_useCoupon">{{$t('Buy_Now')}}</button><button class="not_use" @click="e_notUseCoupon">{{$t('Dont_Use_Any')}}</button></div>
    </div>
    
</template>

<script>
import { Toast } from 'vant';
import checkProjectConfig from '@/lib/checkProjectConfig';
export default {
    name: 'com_coupon',
    props:{
        dataList:{
            type:Object,
            default:{}
        }
    },
    components: {
        Toast,
    },
    data() {
        return {
            showCoupon: true,
            select_type: 'public',
            publicCouponCode: '',
            comActive:[],//优惠券选中
            showUsefulDesc:[],//可用优惠券描述标识
            showUselessDesc:[],//不可用优惠券描述标识
            selectCoupon:{},//选中的优惠券
        }
    },
    computed: {
        Module_Coupon:function(){
            return checkProjectConfig.setAppThat(this).checkValue("Module_Coupon",false);
        },
    },
    methods: {
        selectType(type) {
            this.select_type = type;
        },
        //查看可用优惠券描述
        e_usefulDescToggle(e){
            let parDom = document.querySelectorAll(".coupon_desc_useful"),childDom = document.querySelectorAll(".coupon_desc_useful .coupon_desc");
            if(this.showUsefulDesc[e]){//已显示desc则隐藏
                this.showUsefulDesc.splice(e,1,0);
                parDom[e].style.height = "0px";
            }else {//反之则显示
                this.showUsefulDesc.splice(e,1,1);
                parDom[e].style.height = childDom[e].offsetHeight + "px";
            }
        },
        //查看不可用优惠券描述
        e_uselessDescToggle(e){
            let parDom = document.querySelectorAll(".coupon_desc_useless"),childDom = document.querySelectorAll(".coupon_desc_useless .coupon_desc");
            if(this.showUselessDesc[e]){//已显示desc则隐藏
                this.showUselessDesc.splice(e,1,0);
                parDom[e].style.height = "0px";
            }else {//反之则显示
                this.showUselessDesc.splice(e,1,1);
                parDom[e].style.height = childDom[e].offsetHeight + "px";
            }
        },
        // 关闭弹框
        e_closeDialog(){
            let that = this;
            that.$emit("closeCoupon");
        },
        //设置默认选中
        e_setActiveDefault(){
            let that = this,da = this.dataList.availableList;
            that.comActive.length = 0;
            that.showUsefulDesc.length = 0;
            that.showUselessDesc.length = 0;
            for(let i in da){
                that.showUsefulDesc.push(0);
                that.showUselessDesc.push(0);
                if(da[i].promotionCode==that.dataList.selectedCoupon.promotionCode && da[i].id==that.dataList.selectedCoupon.id ){
                    that.comActive.push(1);
                    this.selectCoupon = da[i]
                    that.$nextTick(()=>{
                        document.querySelector(".coupon_li.active") && document.querySelector(".coupon_li.active")?.scrollIntoView(true);
                    })
                }else{
                    that.comActive.push(0);
                }
            }
        },
        // 选择优惠券
        e_chooseCoupon(data,index){
            let that = this;
            let i = that.comActive.indexOf(1);
            that.comActive.splice(i,1,0);
            that.comActive.splice(index,1,1);
            that.selectCoupon = data;
        },
        //确定使用优惠券
        e_useCoupon(){
            let that = this;
            if( JSON.stringify(that.selectCoupon)=="{}" && that.select_type=="private" ){
                that.$toast(this.$t('please_Select_Coupon_use'))
                    
                return;
            }
            if(!that.publicCouponCode && that.select_type=="public"){
                that.$toast(this.$t('please_Enter_Promo_code'))
                return;
            }
            if(that.select_type=="private"){//个人优惠券
                that.$emit("chooseCoupon",that.selectCoupon,that.select_type);
                that.$emit("closeCoupon");
            }else{//公共优惠券
                that.$emit("chooseCoupon",that.publicCouponCode,that.select_type);
            }
        },
        //不使用任何优惠券
        e_notUseCoupon(){
            let that =this;
            if(JSON.stringify(that.dataList.selectedCoupon)=="{}"){
                that.$emit("closeCoupon");
            }else{
                that.$emit("chooseCoupon",{},that.select_type);
                that.$emit("closeCoupon");
            }
        },
    },
    mounted(){
        this.e_setActiveDefault();
        if(this.dataList.availableList.length){
            this.select_type = 'private'
        }
    },
}
</script>

<style>
.clear {zoom:1}

.clear:after,.clear:before {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0
}
.coupon-wrap{position: relative;background: #f1f1f1;}
.coupon_switch {position: relative;display: flex; border-radius: 0.2rem 0.2rem 0 0;padding: 0.85rem 0 .56rem 0;background: #fff;box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);}
.coupon_switch button {width: 100%;box-sizing: border-box;float: left;margin: 0 auto;color: #666;font-size: 0.48rem;background: #fff;font-weight: normal;border: 0;outline: 0;}
.coupon_switch .private_coupon {border-right: 1px solid #EDEDED;}
.coupon_switch button.selected {color: #1CA64A;}
.coupon_switch .coupon_close {position: absolute;top: 0.1rem;right: 0.1rem;color: #999;font-size: 0.24rem;padding: 0.1rem;}
.private_coupon_box {min-height: 8.6rem;padding: 0 0.16rem .2rem;overflow: auto;}
.private_coupon_box .type_title {font-size: 0.28rem;color: #333;display: block;padding: 0.16rem 0;font-weight: 500;}
.private_coupon_box .coupon_li{margin-bottom: 0.16rem;position: relative;}
.private_coupon_box .coupon_li:last-child{margin-bottom: 0;}
.private_coupon_box .coupon_li .selected{position: absolute;top: 0;right: 0;width: 0.56rem;z-index: 10;display: none;}
.private_coupon_box .coupon_li.active .selected{display: block;}
.private_coupon_box .coupon_item {border-top-right-radius: 0.16rem;border-bottom-right-radius: 0.16rem;border-top-left-radius: 0.16rem;border-bottom-left-radius: 0.16rem;overflow: hidden;}
.available_coupon,.coupon_wrap{position: relative;}
.available_coupon .coupon_wrap{max-height: 5rem;overflow-y: auto;}
.available_coupon .coupon_wrap_all,.unavailable_coupon .coupon_wrap_all{max-height: 8.6rem !important;}
.unavailable_coupon .coupon_wrap{max-height: 4.5rem;overflow-y: auto;}
.coupon_item .coupon_left{width: 1.97rem;height: 1.84rem;display: flex;flex-direction: column;justify-content: center;align-items: center;position: relative;}
.coupon_item .coupon_denomination{position: relative;overflow: hidden;}
.coupon_item .coupon_denomination::before{display: block;top:8px;height: 100%;position: absolute;border-left: 8px dotted #f1f1f1;transform: translateX(-50%);z-index: 111;}
.coupon_direct_reduction {background-image: linear-gradient(-45deg, #F1B322 0%, #F7D034 100%);}
.coupon_percent_reduction {background-image: linear-gradient(-45deg, #6BBC46 0%, #79D24D 100%);}
.coupon_full_reduction {background-image: linear-gradient(135deg, #FFB332 0%, #FF8000 100%);}
.coupon_full_reduction_percent {background-image: linear-gradient(-45deg, #4179EB 0%, #59BDF3 100%);}
.coupon_useless {background: #DBDBDB;}
.coupon_left p {font-size: 0.66rem;color: #fff;font-weight: bold;}
.coupon_left span {font-size: 0.28rem;color: #fff;font-weight: bold;}
.coupon_item .coupon_right {position: relative;width: calc(100% - 1.97rem);height: 1.84rem;background: #fff;padding-left: 0.2rem;}
.coupon_right .coupon_name {font-size: 0.32rem;color: #333;font-weight: 500;height: 0.72rem;line-height: 0.36rem;overflow: hidden;margin-top: 0.15rem;}
.coupon_right .coupon_title, .coupon_right .coupon_date {font-size: 0.24rem;color: #666;margin-top: 0.08rem;line-height: .28rem;padding-right: 0.08rem;display: flex; justify-content: space-between;}
.coupon_right .more{display: inline-block;width: 0.32rem;height: 0.32rem;background: #DBDBDB;border-radius: 50%;vertical-align: bottom;margin-left: 0.2rem;position: relative;}
.coupon_right .more.active{background: #1CA64A;}
.coupon_right .more::after {content: '';display: block;border-width: 5px;border-style: solid;border-color: #fff transparent transparent transparent;position: absolute;top: 70%;left: 50%;transform: translate(-50%, -50%);}
.coupon_right .more.active::after{border-color: transparent transparent #fff transparent;top: 30%;}
.coupon_item .coupon_desc_wrap{background: #fff;overflow: hidden;border-bottom-left-radius: 0.16rem;clear: both;height: 0;transition: all .3s;}
.coupon_item .coupon_desc {padding: 0.16rem 0.32rem 0.32rem;}
.coupon_item .coupon_desc label {font-size: 0.24rem;color: #999;}
.public_coupon_box {padding: 1.4rem 0;min-height: 9rem}
.public_coupon_box .title {font-size: 0.42rem;color: #333;margin-left: 0.32rem;margin-bottom: 0.2rem;display: inline-block;}
.public_coupon_box .coupon_input {margin: 0.15rem 0.2rem;width: calc(100% - 0.4rem);padding: 0.4rem;background: #FFFFFF;border: 1px solid #E3E3E3;box-sizing: border-box;font-size: 0.42rem;color: #333;}
.public_coupon_box p{margin-left: 0.6rem;font-size: .24rem;display: block;height: .3rem;line-height: .3rem;}
.public_coupon_box p.available{color: #1FC10A;}
.public_coupon_box p.unavailable{color: #FF6709;}
.coupon-wrap .operator {background: #fff;box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);text-align: center;display:flex;justify-content:center}
.operator button {width: 3.2rem;height: 1.2rem;font-size: 0.38rem;color: #fff;border-radius: 8px;margin: 0.26rem auto;margin-right:0;margin-left:0}
.operator button.buy_now {background: #1CA64A;margin-right: 0.42rem;}
.operator button.not_use {background: #ccc;}
.coupon-wrap .nullList{position:relative;width:100%;min-height: 5.98rem;padding-top: 1rem;margin-bottom: 0.6144rem;}
.coupon-wrap .nullList img{display: block;width:100%; margin: 0 auto;}
.coupon-wrap .nullList p{display: block;text-align: center;width:100%;color:#999;font-size: 0.3072rem;}
</style>

<style lang="less" scoped>
@import "~@/assets/theme.less";
.coupon-wrap {
    .coupon_switch button.selected {color: @theme-color;}
    .operator button.buy_now {background: @theme-color;}
}
 html[dir="rtl"] .coupon-wrap {
     .public_coupon_box {
         .title {
             margin-left: 0;
             margin-right: 0.32rem;
         }
     }
     .operator {
         button.buy_now {
             margin-right: 0;
         }
         button.not_use {
             margin-right: 0.42rem;
         }
     }
     .private_coupon_box {
         .fl {
             float:right;
         }
         .coupon_item .coupon_right {
             padding-left: unset;
             padding-right: 0.2rem;
         }
         .coupon_item {
             border-top-right-radius: 0.16rem;
             border-bottom-right-radius: 0.16rem;
             border-top-left-radius: 0.16rem;
             border-bottom-left-radius: 0.16rem;
         }
         .coupon_item .coupon_denomination::before{
             right: -8px;
         }
     }  
 }
</style>
